import { render } from "./SectionContact.vue?vue&type=template&id=beac6a1e&scoped=true"
import script from "./SectionContact.vue?vue&type=script&lang=js"
export * from "./SectionContact.vue?vue&type=script&lang=js"

import "./SectionContact.vue?vue&type=style&index=0&id=beac6a1e&scoped=true&lang=stylus"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-beac6a1e"]])

export default __exports__